module.exports = __webpack_public_path__ + "static/media/only_ceni6.d889920b.svg";